import anime from 'animejs';
import root from 'window-or-global';
import { keyframes } from 'styled-components';

export const KEY_FRAMES = {
  FADE_IN: keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  `,
};

export const dropAnimation = (targets) => {
  anime({
    targets,
    duration: 1500,
    opacity: 1,
    translateY: [-700, 0],
  });
};

export const screenChangeAnimation = (targets) => {
  anime({
    targets,
    delay: 200,
    easing: 'easeOutSine',
    translateX: [260, 0],
    opacity: [0, 1],
    duration: 250,
  });
};

export const delayedOpacityAnimation = (targets, delay = 200, isCompletedCallback = () => {}) => {
  anime({
    targets,
    easing: 'linear',
    opacity: [0, 1],
    delay: (el, index) => index * delay,
    duration: delay,
    complete: isCompletedCallback,
  });
};

export const hideToRightAnimation = (targets) => {
  anime({
    targets,
    easing: 'easeOutSine',
    opacity: [1, 0],
    translateX: [0, 1000],
    duration: 350,
  });
};

export const hideToLeftAnimation = (targets) => {
  anime({
    targets,
    easing: 'easeOutSine',
    opacity: [1, 0],
    translateX: [0, -1000],
    duration: 350,
  });
};

export const showToRightAnimation = (targets) => {
  anime({
    targets,
    easing: 'easeOutSine',
    opacity: [0, 1],
    delay: 25,
    translateX: [-1000, 0],
    duration: 350,
  });
};

export const showToLeftAnimation = (targets) => {
  anime({
    targets,
    easing: 'easeOutSine',
    opacity: [0, 1],
    delay: 25,
    translateX: [1000, 0],
    duration: 350,
  });
};

export const scrollToElement = (target, delayInMilliseconds, behavior = 'smooth') => {
  setTimeout(() => {
    target.scrollIntoView({
      behavior,
      block: 'start',
    });
  }, delayInMilliseconds);
};

export const scrollTo = (top, left) => {
  root.scroll({
    top,
    left,
    behavior: 'smooth',
  });
};

export const FADE_VALUES = {
  BOX: {
    LIGHT: '10px',
    SMALL: '50px',
    LARGE: '100px',
  },
  TEXT: {
    SMALL: '1em',
    LARGE: '2em',
  },
  DELAY: {
    SMALL: 200,
    LARGE: 1000,
  },
};

export const parallaxImage = (reference, topMaxValue, topMinValue, animationSpeed) => {
  const imageParams = reference.getBoundingClientRect();
  let top = topMinValue;
  top += (((imageParams.top - root.innerHeight) / animationSpeed) * -1);
  reference.style.top = `${top}px`;
  if (top < topMinValue) {
    reference.style.top = `${topMinValue}px`;
  } else if (top > topMaxValue) {
    reference.style.top = `${topMaxValue}px`;
  }
};


export const parallaxImageTranslateY = (reference, topMaxValue, topMinValue, animationSpeed) => {
  const imageParams = reference.getBoundingClientRect();
  let top = topMinValue;
  top += (((imageParams.top - root.innerHeight) / animationSpeed) * -1);
  reference.style.transform = `translateY(${top}px)`;
  if (top < topMinValue) {
    reference.style.transform = `translateY(${topMinValue}px)`;
  } else if (top > topMaxValue) {
    reference.style.transform = `translateY(${topMaxValue}px)`;
  }
};

export const scaleImage = (reference, scaleMax, scaleMin) => {
  const imageParams = reference.getBoundingClientRect();
  let scale = scaleMin;
  scale += (((imageParams.top - root.innerHeight) / 5000) * -1);
  reference.style.transform = `scale(${scale})`;
  if (scale > scaleMax) {
    reference.style.transform = `scale(${scaleMax})`;
  } else if (scale < scaleMin) {
    reference.style.transform = `scale(${scaleMin})`;
  }
};



// WEBPACK FOOTER //
// ./src/animations/Animations.js